/**
 * Type-tag filter on a catalogue: chosen tag ids live in the URL (?tags=a,b) so Back, refresh and a
 * shared link keep them. A piece matches when it has any chosen tag.
 */
export function typeTagsFromSearch(search: string): string[] {
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  const out: string[] = [];
  for (const part of (params.get("tags") || "").split(",")) {
    const id = part.trim();
    if (id && !out.includes(id)) out.push(id);
  }
  return out;
}

/** Params with the tags set (or removed) and the page reset, since results change. */
export function withTypeTags(params: URLSearchParams, ids: string[]): URLSearchParams {
  const next = new URLSearchParams(params);
  next.delete("tags");
  next.delete("page");
  if (ids.length) next.set("tags", ids.join(","));
  return next;
}

export function toggleTypeTag(current: string[], id: string): string[] {
  return current.includes(id) ? current.filter((t) => t !== id) : [...current, id];
}
